<template>
  <div>
    <!--- Navigator-->
    <b-row>
      <b-col cols="3">
        <h3><b>จัดการลูกค้า</b></h3>
        <small>
          <span class="text-primary" style="cursor: pointer;"
            @click="$router.push('/setting/customer/owner')"><b>จัดการลูกค้า</b> ></span>
          <span class="text-primary" @click="$router.push(navPath('company'))" style="cursor: pointer;"><b>
              {{ $route.query.ownerName }}</b> ></span>
          <span class="text-primary" @click="$router.push(navPath('previous'))" style="cursor: pointer;"><b>
              {{ $route.query.companyName }}</b> ></span>
          <b>Brand</b>
        </small>
      </b-col>
      <b-col class="d-flex justify-content-end align-items-center">
        <b-button v-if="customerPermission == 'create' || customerPermission == 'edit'" variant="primary" size="sm"
          style="height: 35px" class="mr-1" @click="save" :disabled="isLoading">
          <feather-icon icon="SaveIcon" />
          บันทึก
        </b-button>

        <b-button variant="outline-dark" size="sm" @click="$router.push(navPath('previous'))" style="height: 35px">
          <feather-icon icon="ArrowLeftIcon" />
          ย้อนกลับ
        </b-button>
      </b-col>
    </b-row>
    <!--- Navigator-->

    <b-row class="mt-1">
      <b-col cols="12">
        <b-card>
          <b-row>
            <b-col>
              <h2><b>{{ mode == 'create' ? 'เพิ่ม Brand' : 'แก้ไข Brand' }}</b></h2>
            </b-col>
          </b-row>

          <!--- START (ชื่อบริษัท) --->
          <b-row class="mt-2">
            <b-col md="3" class="">
              <label>ชื่อ Brand</label>
              <b-form-input placeholder="Vserv" size="sm" value="Vserv" v-model="subCompanyData.subCompanyName" />
            </b-col>

            <b-col md="2" class="">
              <label>สถานะ </label>
              <b-form-group>
                <b-form-radio-group v-model="subCompanyData.status" :options="statusOptions" name="status" />
              
              </b-form-group>
            </b-col>

            <b-col md="2" class="">
              <label>แจ้งเตือนสี SLA</label>
              <b-form-group>
                <b-form-radio-group v-model="subCompanyData.isShowSlaAlertColor" :options="statusOptions" name="isShowSlaAlertColor" />
              </b-form-group>
            </b-col>

            <b-col md="3" class="">
              <label>จำเป็นต้องใส่ช่องเวลาแจ้งงานเมื่อเปิดใบงาน </label>
              <b-form-group>
                <b-form-radio-group v-model="subCompanyData.isRequiredInputResponseTime" :options="requiredResponseOptions" name="isRequiredInputResponseTime" />
              </b-form-group>
            </b-col>

            
          </b-row>
          <!--- END (ชื่อบริษัท) --->

          <!--- START (เบอร์โทร) --->
          <b-row>
            <b-col md="3" class="">
              <label>เบอร์โทร</label>
              <b-form-input placeholder="0987654321" size="sm" value="0987654321" v-model="subCompanyData.tel" />
            </b-col>

            <b-col md="3" class="">
              <label>Email</label>
              <b-form-input placeholder="admin@gmail.com" size="sm" value="admin@gmail.com"
                v-model="subCompanyData.email" />
            </b-col>
          </b-row>
          <!--- END (เบอร์โทร) --->

          <!--- START ROW รายละเอียด --->
          <b-row class="mt-1">
            <b-col md="12">
              <label>รายละเอียด</label>
              <b-form-textarea id="textarea-default" placeholder="รายละเอียด" rows="2" size="sm"
                v-model="subCompanyData.detail" />
            </b-col>
          </b-row>
          <!--- END รายละเอียด --->

          <b-row class="mt-2">
            <b-col md="2" class="">
              <label>SLA setting </label>
              <b-form-group>
                <b-form-radio-group v-model="subCompanyData.isUseSlaSetting" :options="statusOptions" name="isUseSlaSetting" />
               
              </b-form-group>
            </b-col>

            <!-- NEXT FEATURE -->
            <!-- <b-col md="2" class="">
              <label>มีศูนย์บริการหรือไม่?  </label><span class="text-danger ml-1" style="font-size:11px">(สำหรับ CM ต่างจังหวัดเท่านั้น)</span>
              <b-form-group>
                <b-form-radio-group v-model="subCompanyData.isCentralZone" :options="centralOptions" name="isCentralZone" />
               
              </b-form-group>
            </b-col> -->
          </b-row>
        </b-card>
        <!-- END SECTION FORM วันเดินทาง--->
      </b-col>
    </b-row>




    <!-- SLA SETTING-->
  
    <b-alert v-if="subCompanyData.isUseSlaSetting == 0" show variant="danger">
      <div class="alert-body">
          <span ><feather-icon icon="XCircleIcon" size="20"/><strong style="font-size:1.2em"> SLA setting ถูกปิดการใช้งานอยู่</strong> </span>
        </div>
    </b-alert>
    <b-alert v-else show variant="success">
      <div class="alert-body">
          <span style="font-size:1.2em"><strong>  <feather-icon icon="CheckCircleIcon" size="20"/>SLA setting เปิดการใช้งานแล้ว</strong> </span>
        </div>
    </b-alert>

    <b-row class="mt-1">
      <b-col cols="12">
        <b-card>
          <b-tabs content-class="mt-3">
            <b-tab title="Helpdesk" active @click="onClickTab('helpdesk')">
              <HelpdeskTab :isTriggerFetch="isTriggerHelpdesk"/>
            </b-tab>
            <b-tab title="CM" @click="onClickTab('cm')">
              <CMTab :is-have-central="subCompanyData.isCentralZone" :isTriggerFetch="isTriggerCm"/>
            </b-tab>
            <b-tab title="Software bug fix" @click="onClickTab('problemBugFix')">
              <ProblemBugFixTab :isTriggerFetch="isTriggerFetchProblemBugFix"/>
            </b-tab>
          </b-tabs>
        </b-card>
        <!-- END SECTION FORM วันเดินทาง--->
      </b-col>
    </b-row>
    <SettingSlaDateModal @onSubmit="onSubmitSlaDate"/>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BFormGroup,
  BButton,
  BFormCheckbox,
  BInputGroup,
  BFormInput,
  BFormTextarea,
  BFormRadioGroup,
  BTab,
  BTabs,
  BAlert
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import ProblemBugFixTab from "../components/tabs/problemBugFix.vue"
import HelpdeskTab from "../components/tabs/helpdesk.vue"
import CMTab from "../components/tabs/cm.vue"
import SettingSlaDateModal from "../components/modal/settingSlaDate.vue"

//SERVICES
import CustomerService from "@/services/setting/customer";
import CatService from "@/services/setting/cat";



export default {
  components: {
    BRow,
    BCol,
    BCard,
    BFormGroup,
    BButton,
    BFormInput,
    BInputGroup,
    BFormCheckbox,
    BFormTextarea,
    BFormRadioGroup,
    BTab,
    BTabs,
    BAlert,
    HelpdeskTab,
    CMTab,
    ProblemBugFixTab,
    SettingSlaDateModal
  },
  data() {
    return {
      statusOptions: [
        { text: 'เปิด', value: 1 },
        { text: 'ปิด', value: 0 },
      ],
      requiredResponseOptions: [
        { text: 'เปิด', value: 1 },
        { text: 'ปิด (Default)', value: 0 },
      ],
      centralOptions: [
        { text: 'มี', value: 1 },
        { text: 'ไม่มี', value: 0 },
      ],
      isTriggerCm: false,
      isTriggerHelpdesk: false,
      isTriggerFetchProblemBugFix: false,
      subCompanyData: {
        subCompanyName: "",
        detail: "",
        tel: "",
        email: "",
        status: 1,
        isCentralZone:0,
        isShowSlaAlertColor:0,
        isRequiredInputResponseTime:0,
        isUseSlaSetting:0
      },  
      isLoading: false
    };
  },

  computed: {
    customerPermission() {
      const permission = this.$store.getters["user/getPermissionPage"]("ST003")
      if (permission == "disable") {
        localStorage.removeItem("userData")
        window.location.href = "/not-authorized"
      }
      return permission
    },
    mode() {
      const subCompanyId = this.$route.query.scid
      if (subCompanyId) {
        return "edit"
      }
      return "create"
    },
    paramSubCompanyId() {
      return this.$route.query.scid
    },
    paramCompanyId() {
      return this.$route.query.cid
    }
  },


  methods: {
    navPath(type) {
      switch (type) {
        case "previous":
          return `/setting/customer/sub-company?oid=${this.$route.query.oid}&cid=${this.$route.query.cid}&ownerName=${this.$route.query.ownerName}&companyName=${this.$route.query.companyName}`
        case "company":
          return `/setting/customer/company?oid=${this.$route.query.oid}&cid=${this.$route.query.cid}&ownerName=${this.$route.query.ownerName}&companyName=${this.$route.query.companyName}`


        default:
          break;
      }
    },
    async save() {
      if (!this.subCompanyData.subCompanyName) {
        alert("กรุณากรอกชื่อ Brand")
        return
      }
      if (this.mode == 'create') {
        await this.insert()
      } else {
        await this.update()
      }
    },

    async getCustomerSubCompanyDetail() {
      const result = await CustomerService.GetCustomerSubCompanyById(this.paramSubCompanyId)
      this.subCompanyData = {
        ...result.data,
        isCentralZone: result.data?.isCentralZone ? 1 : 0,
        isShowSlaAlertColor: result.data?.isShowSlaAlertColor ? 1 : 0,
        isRequiredInputResponseTime: result.data?.isRequiredInputResponseTime ? 1 : 0,
        isUseSlaSetting: result.data?.isUseSlaSetting ? 1 : 0
      }
    },
    async insert() {
      this.isLoading = true
      const result = await CustomerService.InsertCustomerSubCompany({ ...this.subCompanyData, companyId: this.paramCompanyId })
      if (result.status == "success") {
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: `Brand`,
            icon: "CheckIcon",
            variant: "success",
            text: `เพิ่มรายการเรียบร้อย`,
          },
        });

        this.$router.push(this.navPath('previous'))

      } else {
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: `Brand`,
            icon: "XIcon",
            variant: "danger",
            text: `พบปัญหาในการเพิ่มรายการ`,
          },
        });
      }

      this.isLoading = false

    },
    async update() {
      this.isLoading = true
      const result = await CustomerService.UpdateCustomerSubCompany(this.subCompanyData, this.paramSubCompanyId)
      if (result.status == "success") {
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: `Brand`,
            icon: "CheckIcon",
            variant: "success",
            text: `แก้ไขรายการเรียบร้อย`,
          },
        });
        this.$router.push(this.navPath('previous'))
      } else {
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: `Brand`,
            icon: "XIcon",
            variant: "danger",
            text: `พบปัญหาในการแก้ไขรายการ`,
          },
        });
      }
      this.isLoading = false
    },
    onClickTab(tab) {
      this.setTabSelectedToStore(tab)
    },
    setTabSelectedToStore(tab) {
      this.$store.commit('sla/SET_TAB_SELECTED', tab)
    }, 
    async onSubmitSlaDate(data, isNew, type){
      let payload = {...data}
      console.log("onsubmit=>", payload, isNew, type)

      //IF CM TYPE IS NOT BANGKOK
      const cmType = this.$store.getters["sla/getCmTypeSelected"]
      if(type=="cm"){
        payload = data.map(timeSetting=>{
          return {
            ...timeSetting,
            cmType:cmType
          }
        })
      }else{
        payload = data.map(timeSetting=>{
          return {
            ...timeSetting,
            cmType:""
          }
        })
      }



      if(type=="cm"){
        this.isTriggerCm = !this.isTriggerCm
      }else if(type=="helpdesk"){
        this.isTriggerHelpdesk = !this.isTriggerHelpdesk
      }else if(type=="problemBugFix"){
        this.isTriggerProblemBugFix = !this.isTriggerProblemBugFix
      }

      if(isNew){
        await CatService.InsertCatTime(payload)
      }else{
        await CatService.UpdateCatTime(payload)
      }
     
    }  
  },

  mounted() {
    if (this.mode == "edit") {
      this.getCustomerSubCompanyDetail()
    }

    this.setTabSelectedToStore("helpdesk")  
  
  }
};
</script>
<style scoped>
.table-responsive {
  overflow: none !important;
}
</style>
